import axios from "axios";
import decrypt from "../../utils/helpers/decrypt";
import encrypt from "../../utils/helpers/encrypt";
import StorageService from "../storage/storage.service";
import { showMessageOnFailure } from "../../store/error.actions";
import store from "../../store/store";
import { APIResponseCodes } from "../../utils/constants/Keys.constants";
import { setUser } from "../../store/authentication/authentication.slice";
import { refreshToken } from "../../store/authentication/authentication.actions";
import { hideLoader } from "../../store/Loader/loader.slice";
import { saveAs } from 'file-saver';

/**
 * HTTP service functions will be used to make all the api calls
 *
 */

// const baseURL = "http://uat.dhlapi.asmadiya.com/dhl/api";
const baseURL = "https://dev.dhlapi.asmadiya.com/dhl/api";
// const baseURL = "https://dhlapi.procialize.in/dhl/api"

/** Header creation */
const createHeaders = (responseType: string = 'application/json, text/plain, */*') => {
    axios.defaults.baseURL = baseURL;
    const { user } = StorageService.getFromStorage(["user"]);

    return {
        headers: {
            Authorization: "Bearer " + user?.token,
            "Content-Security-Policy": "default-src 'self'; img-src https: data:; script-src 'self'; style-src 'self' 'unsafe-inline';",
            "Content-Type": "application/json",
            "X-Frame-Options": "SAMEORIGIN", 
            "X-Content-Type-Options": "nosniff", 
            "Referrer-Policy": "no-referrer-when-downgrade", 
            "Permissions-Policy": "geolocation=(), microphone=(), camera=()", 
        },        
        
    };
};



/** HTTP - GET */
const getDetails = async (getUrl: string, callbackFun?: Function) => {
    try {
        const header = createHeaders();
        const response: any = await axios.get(getUrl, header).catch((reason) => {
            if (reason.response) {
                return reason.response;
            }
        });

        if (response?.status === 401) {
            if (response.data?.statusCode === APIResponseCodes.INVALID_ACCESS_TOKEN) {
                let callback =
                    typeof callbackFun === "undefined" ? () => { } : callbackFun;
                store.dispatch(hideLoader());
                refreshToken(getUrl, callback);
                return response.data;
            }

            localStorage.clear();
            sessionStorage.clear();
            store.dispatch(
                setUser({
                    user_id: "",
                    roleName: "",
                    email: "",
                    token: "",
                    isNewUser: false,
                })
            );
            store.dispatch(
                showMessageOnFailure("Your session expired. Please login again...")
            );
            return response.data;
        }

        if (response.status === 400) {
            store.dispatch(showMessageOnFailure(response.data.message));
            return response.data;
        }

        if (response?.status === 200) {
            let decryptedPayload = await decrypt(response.data.data);
            return {
                statusCode: response.data.statusCode,
                message: response.data.message,
                data: decryptedPayload,
            };
        }

        return response;
    } catch (error) {
        return {
            statusCode: APIResponseCodes.SERVER_ERROR,
            message: "server error",
        };
    }
};

/** HTTP - POST ( to post JSON data) */
const postDetails = async (
    postUrl: string,
    payload: any,
    callbackFun?: Function,
    responseType: string = 'application/json, text/plain, */*',
) => {

    // console.log(responseType)
    const header = createHeaders(responseType);


    try {
        const response: any = await axios
            .post(postUrl, { data: encrypt(payload) }, header)
            .catch((reason) => {
         
                if (reason.response) {
                    return reason.response;
                }
            });
        
        
            //    console.log("Reason", response)
                if (responseType === 'blob') {
                    return response.data;
                }

        if (response?.status === 401) {
            if (response.data?.statusCode === APIResponseCodes.INVALID_ACCESS_TOKEN) {
                let callback =
                    typeof callbackFun === "undefined" ? () => { } : callbackFun;
                refreshToken(postUrl, callback);
                return response.data;
            }

            localStorage.clear();
            sessionStorage.clear();
            // store.dispatch(
            //   setUser({
            //     user_id: "",
            //     roleName: "",
            //     email: "",
            //     token: "",
            //     isNewUser: false,
            //   })
            // );
            store.dispatch(
                showMessageOnFailure("Your session expired. Please login again...")
            );
            return response.data;
        }

        if (response.status === 404) {
            store.dispatch(
                showMessageOnFailure("Unable to make request with given details...")
            );
        }

        if (response.status === 400) {
            store.dispatch(showMessageOnFailure(response.data.message));
            return response.data;
        }

        if (response?.status === 403) {
            localStorage.clear();
            sessionStorage.clear();
            store.dispatch(
                showMessageOnFailure(
                    "You don't have access to this page. Please contact your organisation admin..."
                )
            );
        }

        if (response.status === 200) {
            let decryptedPayload = await decrypt(response.data.data);
            return {
                statusCode: response.status,
                message: response.data.message,
                data: decryptedPayload,
            };
        }

        return response;
    } catch (error) {
        store.dispatch(
            showMessageOnFailure(
                "Sorry for the inconvenience. We are having trouble processing your request at the moment. Please try again some time later..."
            )
        );
        return {
            statusCode: APIResponseCodes.SERVER_ERROR,
            message: "server error",
        };
    }
};

/** Post Multipart Data ( to post Form Data) */
const postMultipartDetails = async (
    postUrl: string,
    formData: any,
    callbackFun?: Function
) => {
    const { user } = StorageService.getFromStorage(["user"]);

    try {
        const response: any = await axios
            .post(postUrl, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${user.token}`,
                },
            })
            .catch((reason) => {
                if (reason.response) {
                    return reason.response;
                }
            });

        if (response?.status === 401) {
            if (response.data?.statusCode === APIResponseCodes.INVALID_ACCESS_TOKEN) {
                let callback =
                    typeof callbackFun === "undefined" ? () => { } : callbackFun;
                refreshToken(postUrl, callback);
                return response.data;
            }

            localStorage.clear();
            store.dispatch(
                showMessageOnFailure("Your session expired. Please login again...")
            );
            return response.data;
        }

        if (response.status === 404) {
            store.dispatch(
                showMessageOnFailure("Unable to make request with given details...")
            );
        }

        if (response.status === 400) {
            store.dispatch(showMessageOnFailure(response.data.message));
            return response.data;
        }

        if (response?.status === 403) {
            store.dispatch(
                showMessageOnFailure(
                    "You don't have access to this page. Please contact your organisation admin..."
                )
            );
        }

        if (response.status === 200) {
            let decryptedPayload = await decrypt(response.data.data);
            return {
                statusCode: response.status,
                message: response.data.message,
                data: decryptedPayload,
            };
        }

        return response;
    } catch (error) {
        store.dispatch(
            showMessageOnFailure(
                "Sorry for the inconvenience. We are having trouble processing your request at the moment. Please try again some time later..."
            )
        );
        return {
            statusCode: APIResponseCodes.SERVER_ERROR,
            message: "server error",
        };
    }
};

/** HTTP - POST without headers [used for login purpose] */
const postWithoutCredentials = async (postUrl: string, payload: any) => {
    axios.defaults.baseURL = baseURL;

    try {
        const response: any = await axios
            .post(postUrl, { data: encrypt(payload) })
            .catch((reason) => {
                if (reason.response) {
                    return reason.response;
                }
            });

        if (response.status === 404) {
            store.dispatch(
                showMessageOnFailure("Unable to make request with given details...")
            );
        }

        if (response.status === 400) {
            store.dispatch(showMessageOnFailure(response.data.message));
            return response.data;
        }

        if (response?.status === 403) {
            store.dispatch(
                showMessageOnFailure(
                    "You don't have access to this page. Please contact your organisation admin..."
                )
            );
        }

        if (response.status === 200) {
            console.log(response.data);
            let decryptedPayload = await decrypt(response.data.data);
            return {
                statusCode: response.status,
                message: response.data.message,
                data: decryptedPayload,
            };
        }

        return response;
    } catch (error) {
        store.dispatch(
            showMessageOnFailure(
                "Sorry for the inconvenience. We are having trouble processing your request at the moment. Please try again some time later..."
            )
        );
        return {
            statusCode: APIResponseCodes.SERVER_ERROR,
            message: "server error",
        };
    }
};

/** HTTP - GET without headers */
const getWithoutCredentials = async (getUrl: string) => {
    axios.defaults.baseURL = baseURL;

    try {
        const response: any = await axios.get(getUrl).catch((reason) => {
            if (reason.response) {
                return reason.response;
            }
        });

        if (response.status === 404) {
            store.dispatch(
                showMessageOnFailure("Unable to make request with given details...")
            );
        }

        if (response?.status === 403) {
            store.dispatch(
                showMessageOnFailure(
                    "You don't have access to this page. Please contact your organisation admin..."
                )
            );
        }

        if (response?.status === 200) {
            console.log(response.data);
            let decryptedPayload = await decrypt(response.data.data);
            return {
                statusCode: response.data.statusCode,
                message: response.data.message,
                data: decryptedPayload,
            };
        }

        if (response?.status === 400) {
            store.dispatch(showMessageOnFailure(response.data.message));
            return response.data;
        }

        return response;
    } catch (error) {
        return {
            statusCode: APIResponseCodes.SERVER_ERROR,
            message: "server error",
        };
    }
};

// async function downloadImage(imageUrl: string, body: any) {
//     try {
//         const response = await axios({
//             url: imageUrl,
//             method: "POST",
//             data: body,
//             responseType: "blob", // To handle binary data
//         },);

//         // Save the file locally
//         const url = URL.createObjectURL(response.data);
//         const a = document.createElement("a");
//         a.href = url;
//         a.download = "image.jpg";
//         // Set the filename
//         document.body.appendChild(a);
//         a.click();
//         document.body.removeChild(a);

//         console.log("Image downloaded successfully!");
//     } catch (error: any) {
//         console.error("Error downloading the image:", error.message);
//     }
// }

// const fetchMedia = async (url:string, payload:any) => {
//     try {
//       // Generate headers with the bearer token
//       const headers = createHeaders('application/json');
  
//       // Send a POST request with the payload and set responseType to 'blob' for file download
//       const response = await axios.post(url, {data: encrypt(payload)}, {
//         ...headers,
//         responseType: 'blob',  // This is important for binary file downloads
//       });

//       console.log("response inside fetchmedia",response)

//     //   if (response.data.size === 0) {
//     //     console.log('No media available to download.');
//     //     return; 
//     //   }
  
//       // Create a blob URL from the response data
//       const blob = new Blob([response.data], { type: response.headers['content-type'] });
      
//       // Extract filename from headers or set a default name
//       const fileName = response.headers['content-disposition']
//         ? response.headers['content-disposition'].split('filename=')[1]
//         : 'downloadedMedia.zip';
  
//       // Save the file using file-saver
//       saveAs(blob, fileName);
      
//       console.log('File downloaded successfully');
//     } catch (error) {
//       console.error('Error downloading media:', error);
//     }
//   };

const fetchMedia = async (url: string, payload: any): Promise<{ success: boolean, message: string }> => {
    try {
      // Generate headers with the bearer token
      const headers = createHeaders('application/json');
  
      // Send a POST request with the payload and set responseType to 'blob' for file download
      const response = await axios.post(url, { data: encrypt(payload) }, {
        ...headers,
        responseType: 'blob',  // This is important for binary file downloads
      });
  
      // Check for a successful response with binary data
      if (response.status === 200) {
        // Create a blob URL from the response data
       // const blob = new Blob([response.data], { type: response.headers['content-type'] }); COMMENTED THIS LINE
          const blob = new Blob([response.data], { type: response.headers['content-type'] as string });
  
        // Extract filename from headers or set a default name
       // const fileName = response.headers['content-disposition'] COMMENTED THIS LINE
        //  ? response.headers['content-disposition'].split('filename=')[1] COMMENTED THIS LINE
          const contentDisposition = response.headers['content-disposition'] as string;
          const fileName = contentDisposition
            ? contentDisposition.split('filename=')[1]?.replace(/['"]/g, '') || 'downloadedMedia.zip'
            : 'downloadedMedia.zip';
  
        // Save the file using file-saver
        saveAs(blob, fileName);
  
        return { success: true, message: 'File downloaded successfully' };
      }
  
      // If there's no valid response but not an error, return a generic message
      return { success: false, message: 'Unexpected response from server' };
    } catch (error) {
      // Check if it's an Axios error and the response exists
      if (axios.isAxiosError(error) && error.response) {
        const { status } = error.response;
  
        // Handle specific status codes
        if (status === 400) {
          return { success: false, message: 'No media available for the selected date.' };
        } else if (status === 404) {
          return { success: false, message: 'Media not found for the selected date.' };
        } else {
          return { success: false, message: `An error occurred with status code: ${status}` };
        }
      } else {
        // Handle generic network or unexpected errors
        return { success: false, message: 'A network or unexpected error occurred' };
      }
    }
  };
  

export {
    getDetails,
    postWithoutCredentials,
    postDetails,
    getWithoutCredentials,
    postMultipartDetails,
    fetchMedia
    // downloadImage,
};
